var _defs, _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBomb1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74.695053,
    height: 79.856613,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3755"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.18646,
    stopColor: "#000000",
    id: "stop3757",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    id: "stop3759",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    r: 60.5,
    fy: 422.71432,
    fx: 252.45213,
    cy: 422.71432,
    cx: 252.45213,
    gradientTransform: "matrix(0.6869142055511475,-0.4661601185798645,0.4314882159233093,0.635823130607605,-779.2176513671875,-877.3902587890625)",
    gradientUnits: "userSpaceOnUse",
    id: "radialGradient4245",
    xlinkHref: "#linearGradient3755"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    r: 60.5,
    fy: 422.71432,
    fx: 252.45213,
    cy: 422.71432,
    cx: 252.45213,
    gradientTransform: "matrix(0.7712457180023193,-0.3071424663066864,0.284297913312912,0.7138822674751282,-591.1123046875,-1040.9598388671875)",
    gradientUnits: "userSpaceOnUse",
    id: "radialGradient4247",
    xlinkHref: "#linearGradient3755"
  }))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata7"
  }, "image/svg+xml")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "g3831",
    transform: "matrix(0.39752, 0, 0, 0.39752, 242.749, 368.847)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#radialGradient4245)",
    id: "path3765",
    d: "m-491.00904,-789.50573c0.69021,33.1299 -25.60736,60.5465 -58.73725,61.23671c-33.12989,0.69021 -60.5465,-25.60735 -61.23671,-58.73725c-0.69021,-33.12989 25.60736,-60.5465 58.73725,-61.23671c33.12989,-0.69021 60.5465,25.60736 61.23671,58.73725z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#radialGradient4247)",
    opacity: 0.84039,
    d: "m-491.30633,-782.14605c-2.9055,33.00947 -32.02034,57.41354 -65.0298,54.50803c-33.00946,-2.9055 -57.41354,-32.02033 -54.50803,-65.0298c2.9055,-33.00946 32.02034,-57.41354 65.0298,-54.50803c33.00946,2.9055 57.41354,32.02034 54.50803,65.0298z",
    id: "path2985"
  })), /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    fill: "#000000",
    id: "rect3801",
    width: 7.35251,
    height: 19.47333,
    x: 49.62242,
    y: -6.53891,
    transform: "matrix(0.799088, 0.601214, -0.620856, 0.783925, 0, 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "smoking-fuse"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 4,
    strokeWidth: 2.119,
    stroke: "#5a5a5a",
    fill: "none",
    d: "m53.74042,20.12695c-1.16069,3.43662 -4.85488,1.14587 -5.65661,5.03618c-0.35684,1.73148 -2.00279,2.34731 -2.00279,2.34731",
    id: "path3835"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    strokeWidth: 2.6,
    fillRule: "evenodd",
    fill: "#f75900",
    id: "path4177",
    d: "m62.11097,33.03504l2.77991,-3.79434l4.20036,2.26046l-1.72294,-4.82526l3.60127,-2.81176l-4.50278,-1.03086l-0.59909,-5.07223l-2.77991,3.79434l-4.20035,-2.26046l1.72294,4.82526l-3.60127,2.81177l4.50278,1.03086l0.59908,5.07222z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(18, 67.8699, 8.53176)",
    opacity: 0.69,
    strokeWidth: 2.6,
    fillRule: "evenodd",
    fill: "#f78000",
    id: "path4181",
    d: "m67.634,14.64556l1.36023,-3.48645l3.13167,0.65344l-1.80948,-3.15556l2.0454,-2.95826l-3.16965,0.33092l-1.08627,-3.61169l-1.36023,3.48645l-3.13167,-0.65344l1.80948,3.15556l-2.0454,2.95826l3.16965,-0.33092l1.08627,3.61169z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    strokeWidth: 2.6,
    fillRule: "evenodd",
    fill: "#f7a200",
    id: "path4183",
    d: "m44.44782,12.86516l1.31966,-3.19129l3.04979,0.60291l-1.76586,-2.89271l1.98743,-2.70655l-3.08547,0.2986l-1.06236,-3.30946l-1.31966,3.19129l-3.04979,-0.60291l1.76586,2.89271l-1.98743,2.70655l3.08547,-0.2986l1.06236,3.30946z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBomb1);
export default __webpack_public_path__ + "static/media/bomb1.b8de86e63a48e13d0f8b6c92cb3ab6b7.svg";
export { ForwardRef as ReactComponent };